var map = {
	"./": 4179,
	"./assets/team1.jpg": 4718,
	"./assets/team2.jpg": 2081,
	"./assets/team3.jpg": 5073,
	"./assets/team4.jpg": 6041,
	"./assets/video_thumb.jpg": 1357,
	"./index": 4179,
	"./index.jsx": 4179,
	"./style.scss": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7641;